import { render, staticRenderFns } from "./ResponseList.vue?vue&type=template&id=79bd3dfd"
import script from "./ResponseList.vue?vue&type=script&lang=js"
export * from "./ResponseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports